import React from 'react';
import '../index.css';
import {Button} from "@nextui-org/react";

const Header = () => {
    return (
        <>
            <header>
                <img src="https://www.jerarquicos.com/wp-content/uploads/2024/03/jerarquicossalud_logo.svg" className="logo" alt="logo"/>
                <nav>
                    <a href="https://www.jerarquicos.com/ayudas-economicas" target="_blank">
                        <Button className={"btnHeader"}>
                            Más info
                        </Button>
                    </a>
                    <a href="https://wa.me/+5493425141873" target="_blank">
                        <Button className={"btnHeader"}>
                            Contacto
                        </Button>
                    </a>
                </nav>
            </header>
        </>
    )
};

export default Header;